import React from 'react'
import ReactDOM from 'react-dom'
import Visualisation from './containers/Visualisation'

const removeLoadingState = () => {
  const container = document.getElementsByClassName('charts')?.[0]
  container.classList.remove('charts--loading')
}

ReactDOM.render(<Visualisation />, document.getElementById('charts'), removeLoadingState)
